import React from 'react'

function Container(props) {
  return (
    <div className="Container">
      {props.children}
    </div>
  )
}

export default Container